<style scoped>
.checkin {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  box-sizing: border-box;
  background: #f4f7fc;
}

.checkin_title {
  font-size: 14px;
  color: #5c5c5c;
  margin-bottom: 10px;
}

.checkin_information_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.checkin_information {
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
}

.checkin_information::-webkit-scrollbar {
  display: none;
}

.checkin_information_attendance_visitor {
  width: 400px;
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
}

.checkin_information_attendance {
  width: calc(100% - 420px);
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
}

.checkin_information_attendance_top {
  width: 100%;
  height: 69px;
  line-height: 69px;
  padding: 0 20px;
  color: rgba(0, 0, 0, 0.65);
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.checkin_information_attendance_content {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: calc(100vh - 240px);
}

.checkin_information_single {
  width: calc(100% - 20px);
  height: 130px;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
  padding: 15px 30px 0 30px;
  box-sizing: border-box;
  background: rgba(0, 157, 255, 0.05);
  border: 1px solid rgba(0, 157, 255, 0.1);
  margin: 10px;
  cursor: pointer;
}
.checkin_information_single:hover {
  background: #009dff;
  color: white;
}
.checkin_information_single:hover .visitor_icon {
  background: #fff;
}
.checkin_information_single_icon {
  width: 32px;
  height: 32px;
}
.checkin_information_single_content {
  display: flex;
  align-items: center;
  margin: 10px 0;
  justify-content: start;
}

.visitor_icon{
  width: 60px;
  height: 60px;
  background: rgba(145, 178, 243, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.visitor_manage{
  background: rgba(212,35,122,0.35)
}
.visitor_log{
  background: rgba(95,197,212,0.35)
}
.visitor_setting{
  background: rgba(19, 34, 122, 0.25);
}
.checkin_information_single_people {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.checkin_information_visitor_echart{
  border: 1px solid #e2e6f8;
  margin: 10px;
  border-radius: 10px;
  width: 65%;
}
.checkin_information_visitor_log{
  border: 1px solid #e2e6f8;
  margin: 10px;
  border-radius: 10px;
  padding: 5px;
  flex: 1;
  /*height: calc(50% - 100px);*/
}
.checkin_applet_content{
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dce1fa;
  border-radius: 5px;
  margin: 10px;
  padding: 0 30px;
  width: 35%;
}
.checkin_applet_content .applet{
  text-align: center;
}
.checkin_applet_content .applet_image{
  margin: 10px 0;
}
.checkin_applet_content .applet img{
  width: 60%;
  margin: 5px;
}
.checkin_applet_content .applet .title{
  font-size: 16px;
  color: #313b5e;
  font-weight: bold;
}
</style>

<template>
  <div class="checkin">
    <div class="checkin_title">访客管理 / 访客概览</div>
    <div class="checkin_information">
      <div style="display: flex;justify-content: space-between ;height: 100%;">
        <div class="checkin_information_attendance_visitor">
          <div class="checkin_information_attendance_top">
            <div class="checkin_information_attendance_top_title">快捷入口</div>
          </div>
          <div class="checkin_information_attendance_content">
            <div class="checkin_information_single" @click="handleToVisitor(1)">
              <div class="checkin_information_single_content">
                <div>
                  <div class="visitor_icon">
                    <svg t="1770252367287" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15220" width="28" height="28"><path d="M227.371163 469.821574a1146.835023 1146.835023 0 0 1 243.670443 383.184972 278.149091 278.149091 0 0 0 213.591624-270.469392V469.821574z m597.976548 213.591623a103.995921 103.995921 0 0 0-138.874554-98.396141 103.995921 103.995921 0 1 1 132.874789 132.954786 103.435943 103.435943 0 0 0 5.999765-34.478648z m0 0" p-id="15221" fill="#1296db"></path><path d="M548.318576 985.481351H248.010353a19.279244 19.279244 0 0 0 0 38.478491h300.308223a19.279244 19.279244 0 1 0 0-38.478491z m242.550487-489.900787A123.195168 123.195168 0 0 0 703.99247 531.419158V450.462333H270.169484a116.155445 116.155445 0 0 0-22.959099-131.834829 77.75695 77.75695 0 0 1 0-109.995686 19.279244 19.279244 0 1 0-27.27893-27.27893 116.395435 116.395435 0 0 0 0 164.313555 77.916944 77.916944 0 0 1 4.799811 104.715894H109.055803v131.994823a297.268342 297.268342 0 0 0 576.457392 101.996 123.67515 123.67515 0 1 0 105.355868-188.792596zM665.353986 582.457157a258.709854 258.709854 0 1 1-517.499705 0V488.940824h517.499705z m125.515077 122.075212a85.196659 85.196659 0 1 1 85.196659-85.196659 85.276656 85.276656 0 0 1-85.196659 85.196659z m0 0" p-id="15222" fill="#1296db"></path><path d="M385.364966 279.989019a19.359241 19.359241 0 0 0 13.51947 32.958708 18.639269 18.639269 0 0 0 13.51947-5.679778 116.395435 116.395435 0 0 0 0-164.313555 77.75695 77.75695 0 0 1 0-109.995687 19.279244 19.279244 0 0 0-27.198933-27.27893 116.395435 116.395435 0 0 0 0 164.313556 77.676954 77.676954 0 0 1 0 109.995686z m195.432336 75.117054a19.359241 19.359241 0 0 0 13.51947 32.958708A18.639269 18.639269 0 0 0 607.996235 382.385003a116.395435 116.395435 0 0 0 0-164.313555 77.75695 77.75695 0 0 1 0-109.995687 19.279244 19.279244 0 0 0-27.27893-27.27893 116.395435 116.395435 0 0 0 0 164.313556 77.676954 77.676954 0 0 1 0 109.995686z m0 0" p-id="15223" fill="#1296db"></path></svg>
                  </div>
                </div>
                <div style="margin-left: 15px;">
                  <div class="checkin_information_single_people">新建邀约</div>
                  <div>您可通过访客预约填写访客信息，邀约访客来访</div>
                </div>
              </div>
            </div>
            <div class="checkin_information_single" @click="handleToVisitorSetting">
              <div class="checkin_information_single_content">
                <div>
                  <div class="visitor_icon visitor_setting">
                    <svg t="1770370892398" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="55261" width="24" height="24"><path d="M956.130705 720.778233c-1.625612 2.30295-3.83825 4.06403-6.36698 5.192927-8.624774 3.115756-16.165807 8.624774-21.765136 15.849716-5.915421 7.224942-9.121489 16.301274-9.076333 25.648542-0.180624 8.760242 2.483574 17.33986 7.631345 24.47449 4.967147 6.954006 11.921154 12.192089 19.913745 15.082065 1.715924 0.993429 3.341535 2.122327 4.921991 3.341536 3.0706 2.393262 5.283239 5.689641 6.36698 9.392424 0.541871 3.973718 0.406403 8.037747-0.406403 11.966309-0.857962 4.876836-2.257794 9.708515-4.109186 14.26926-1.806235 4.470433-4.154341 8.805398-6.954006 12.824271-2.30295 3.431847-5.418706 6.231512-9.076333 8.173215-2.664197 1.490144-5.644486 2.30295-8.66993 2.438418-2.799665-0.090312-5.59933-0.632182-8.218371-1.670767-3.386691-0.948274-6.818539-1.715924-10.295541-2.257795-4.199497-0.677338-8.489306-0.812806-12.779116-0.406403-4.380121 0.451559-8.66993 1.354677-12.824271 2.664198-4.199497 1.309521-7.947436 3.747938-10.927724 6.999162-6.321824 6.36698-10.340698 14.630507-11.469595 23.526216-1.128897 8.579618 0.135468 17.249548 3.702783 25.151828 2.754509 5.283239 2.30295 11.695374-1.219209 16.527053-2.212638 2.709353-4.83168 5.012303-7.857124 6.773383-7.6765 5.012303-16.120651 8.715086-25.01636 10.927724-4.018874 1.038585-8.173215 1.580456-12.327557 1.670768-2.619041-0.045156-5.102615-1.083741-6.999162-2.844821-2.032015-1.715924-3.567315-3.928562-4.470433-6.412135h-0.451558c-3.0706-8.579618-8.398995-16.210963-15.398157-22.081228-7.089474-6.1412-16.210963-9.43758-25.603387-9.302112-9.347268-0.045156-18.378445 3.251224-25.513075 9.302112-7.179786 5.644486-12.688804 13.185518-15.894871 21.71998-1.219209 3.0706-3.477003 5.644486-6.36698 7.224942-2.799665 1.490144-5.915421 2.257794-9.076333 2.257794-4.334965-0.135468-8.624774-0.812806-12.779115-2.07717-4.876836-1.444988-9.708515-3.160912-14.404728-5.147771-4.515588-1.941703-8.805398-4.380121-12.824271-7.270098-3.341535-2.212638-6.231512-4.967147-8.624774-8.173215-1.399832-2.032015-2.167482-4.380121-2.257794-6.818538 0.180624-3.83825 1.264365-7.586189 3.0706-10.972881 3.115756-6.773383 4.334965-14.224104 3.522159-21.629668-0.857962-8.44415-4.515588-16.391586-10.476165-22.442475-3.747938-4.06403-8.624774-6.863694-13.998324-8.082903-5.147771-1.219209-10.431009-1.670768-15.669092-1.399833-6.050889 0.316091-12.011465 1.399832-17.746263 3.251224-3.793094 1.083741-7.857124 0.812806-11.469595-0.857962-3.522159-1.580456-6.502447-4.244653-8.398995-7.631345-5.554174-8.534462-9.527892-18.017198-11.74053-27.996648-1.083741-4.199497-1.354677-8.534462-0.857961-12.824271 0.180624-5.147771 3.431847-9.708515 8.308682-11.514751 8.579618-3.567315 16.256119-9.166645 22.216696-16.301274 13.095207-14.359571 13.095207-36.350487 0-50.710059-6.1412-6.863694-13.727389-12.192089-22.216696-15.669092-2.889977-1.038585-5.192927-3.251224-6.457291-6.050889-1.219209-2.709353-1.851391-5.689641-1.851391-8.66993 0.090312-4.06403 0.632182-8.082903 1.670767-11.966309 2.032015-8.624774 5.689641-16.797989 10.747101-24.068087 1.941703-3.0706 4.560744-5.689641 7.631344-7.6765 1.851391-1.309521 4.109186-1.896547 6.36698-1.670768 2.30295 0.316091 4.560744 0.903118 6.773383 1.670768 8.128059 3.251224 16.933457 4.289809 25.603387 3.0706 8.940865-1.219209 17.249548-5.37355 23.616527-11.74053 3.386691-3.386691 5.915421-7.541033 7.270098-12.146933 2.754509-8.715086 3.702783-17.926886 2.799665-27.048375-0.270935-2.754509-0.632182-5.509018-0.99343-8.218371-0.632182-1.896547-1.128897-3.793094-1.444988-5.779953-0.406403-1.941703-0.180624-3.973718 0.677338-5.779954 1.896547-4.154341 4.967147-7.631345 8.805398-10.069762 4.334965-2.980288 8.940865-5.37355 13.8177-7.270097 8.128059-3.115756 16.662521-5.012303 25.377608-5.644486 3.160912-0.180624 6.276668 1.083741 8.398994 3.477003 1.986859 2.077171 3.477003 4.560744 4.425277 7.270098 3.206068 7.6765 8.308683 14.404727 14.81113 19.597654 6.818539 5.59933 15.398157 8.579618 24.24871 8.398994 9.166645 0.135468 18.152666-2.664197 25.603387-8.082903 7.179786-5.057459 12.643648-12.146933 15.669092-20.365304 1.309521-2.52873 3.025444-4.83168 5.102615-6.818539 1.806235-2.077171 4.334965-3.29638 7.044318-3.477003 4.334965 0 8.624774 0.541871 12.779116 1.670768 4.6059 1.128897 9.076333 2.573885 13.366141 4.470432 4.380121 1.896547 8.489306 4.425277 12.146933 7.450721 3.477003 2.799665 6.502447 6.096044 8.850554 9.843983 1.354677 2.167482 1.76108 4.786524 1.174053 7.270098-0.361247 1.896547-0.903118 3.747938-1.670768 5.554174-3.522159 7.90228-4.651056 16.617366-3.251224 25.151827 1.399832 8.805398 5.59933 16.888301 11.96631 23.074658 6.412136 6.547603 15.127221 10.476165 24.293866 10.97288 9.166645 0.76765 18.378445-0.903118 26.687128-4.741368 5.238083-2.935133 11.74053-2.077171 16.075495 2.07717 4.876836 4.967147 8.579618 10.97288 10.927724 17.520484 3.115756 7.631345 5.283239 15.57878 6.36698 23.751995 0.677338 3.793094-0.270935 7.721656-2.52873 10.882568h0.045156z m-107.109759 11.559907c-14.04348-33.234731-46.691185-54.774088-82.770737-54.638621-11.966309-0.090312-23.797151 2.30295-34.770031 6.999162-45.517132 19.281563-66.785554 71.843013-47.549147 117.360145 4.6059 10.656789 11.063192 20.365304 19.191251 28.673987 16.707677 16.843145 39.466243 26.235569 63.173083 26.145257 23.842307 0.180624 46.826653-9.347268 63.53433-26.325881 25.558231-25.874322 33.054108-64.572915 19.10094-98.168893l0.090311-0.045156z m-406.312651-190.693302c-131.448781-1.806235-236.707148-109.548177-235.48794-240.996957 1.083741-131.448781 108.283812-237.294175 239.732593-236.752304 131.448781 0.632182 237.655422 107.42585 237.610266 238.874631-0.993429 132.713145-109.277241 239.551969-241.990387 238.87463h0.135468z m160.709794 30.84147c-57.754377 47.413679-91.530979 117.947171-92.388941 192.635004-0.812806 74.687833 31.428496 145.94382 88.099132 194.621864H184.010231c-33.821758-0.135468-66.017904-14.404727-88.911938-39.330776-22.848878-24.926048-34.318472-58.251091-31.609119-91.937381 0.857962-20.816863 5.59933-41.272479 13.998324-60.373418 69.088504-139.486528 211.735944-227.35988 367.433435-226.321295 54.277374 0.270935 108.012876 10.611633 158.497156 30.706002z m0 0" p-id="55262" fill="#13227a"></path></svg>
                  </div>
                </div>
                <div style="margin-left: 15px;">
                  <div class="checkin_information_single_people">访客设置</div>
                  <div>您可设置访客通行方式，访客类型配置</div>
                </div>
              </div>
            </div>
            <div class="checkin_information_single" @click="handleToVisitor(0)">
              <div class="checkin_information_single_content">
                <div>
                  <div class="visitor_icon visitor_manage">
                    <svg t="1770252666943" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16349" width="22" height="22"><path d="M283.175649 84.678007c102.951266-105.078033 272.029225-113.5851 384.550941-18.668286A282.269213 282.269213 0 0 1 769.063088 263.8778a281.205829 281.205829 0 0 1-72.546378 210.116681c-87.985129 97.634349-234.653268 121.619552-348.789751 57.619626a435.199498 435.199498 0 0 0-204.799764 153.048438 421.808744 421.808744 0 0 0-81.604829 250.682788c0 9.058451 6.419685 23.473204 22.961204 26.151355 10.633834 2.126767 21.307052 2.638766 34.107038 2.638766h395.224159c15.990135 0 28.750736 12.799985 28.750736 28.829505a29.577812 29.577812 0 0 1-29.30212 29.30212H117.366609c-17.604903 0-29.853504-0.511999-44.780256-3.150766C25.600561 1008.91571 0.000591 981.700972 0.000591 941.725633c0-191.999778 116.26325-373.877722 289.594743-454.419168a280.811984 280.811984 0 0 1-86.921746-195.741312A283.805211 283.805211 0 0 1 283.175649 84.678007z m349.892519 855.432859l339.179916 0.551384c17.092903 0 30.404888 13.351369 30.404888 30.404888a30.050427 30.050427 0 0 1-30.404888 30.404888l-339.179916-0.511999a30.050427 30.050427 0 0 1-30.404888-30.404888c0-17.092903 13.351369-30.404888 30.404888-30.404888z m-120.004785-359.974969c15.478136 0 28.278121 11.224602 29.853504 26.151354l27.766122 194.677929a28.829505 28.829505 0 0 1-8.546451 25.599971c-42.14149 40.526722-67.74146 58.683009-83.219597 58.683009-15.438751 0-42.653489-19.21967-83.180211-59.234393a31.310733 31.310733 0 0 1-9.058452-25.599971l26.11197-194.677929a30.956272 30.956272 0 0 1 30.404888-25.59997z m418.657979 198.419463c17.092903 0 30.404888 13.311985 30.404888 30.404888a30.050427 30.050427 0 0 1-30.404888 30.404888H653.390606a30.050427 30.050427 0 0 1-30.404888-30.404888c0-17.092903 13.311985-30.404888 30.404888-30.404888z m-445.833332-138.161071h-16.02952l-20.243669 153.087823c11.736602 11.185218 20.795053 19.180286 29.30212 25.599971 9.058451-6.931684 18.116902-14.966137 28.829505-25.087971l-21.89782-153.599823z m419.721362-38.399956c17.053519 0 30.404888 13.351369 30.404888 30.404888a30.050427 30.050427 0 0 1-30.404888 30.404888h-252.809554a30.050427 30.050427 0 0 1-30.404888-30.404888c0-8.507067 3.19015-16.541519 9.058451-22.370436a31.192579 31.192579 0 0 1 21.346437-8.034452zM485.848646 60.692804A222.601589 222.601589 0 0 0 263.483364 283.09747a222.601589 222.601589 0 0 0 222.365282 222.365282 222.601589 222.601589 0 0 0 222.404666-222.365282 222.601589 222.601589 0 0 0-222.404666-222.404666z" fill="#d4237a" p-id="16350"></path></svg>
                  </div>
                </div>
                <div style="margin-left: 15px;">
                  <div class="checkin_information_single_people">访客管理</div>
                  <div>您可查询访客申请记录、下载访客码/邀约码</div>
                </div>
              </div>
            </div>
            <div class="checkin_information_single" @click="handleToVisitorLog">
              <div class="checkin_information_single_content">
                <div>
                  <div class="visitor_icon visitor_log">
                    <svg t="1770252798580" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19345" width="24" height="24"><path d="M789.333333 53.333333A117.589333 117.589333 0 0 1 906.666667 170.666667v341.333333a32 32 0 0 1-64 0V170.666667c0-29.269333-24.064-53.333333-53.333334-53.333334h-554.666666c-29.269333 0-53.333333 24.064-53.333334 53.333334v682.666666c0 29.269333 24.064 53.333333 53.333334 53.333334h170.666666a32 32 0 0 1 0 64h-170.666666A117.589333 117.589333 0 0 1 117.333333 853.333333V170.666667A117.589333 117.589333 0 0 1 234.666667 53.333333h554.666666z m-288.981333 748.714667a32 32 0 0 1 58.666667 25.344l-45.610667 122.453333a32 32 0 0 1-59.989333-22.357333l45.653333-122.453333 1.28-2.986667z m90.112 25.898667a32 32 0 1 1 59.861333 22.613333l-37.546666 99.413333a32 32 0 1 1-59.861334-22.613333l37.546667-99.413333z m166.869333-262.613334c37.674667 0 69.546667 30.506667 69.546667 69.12 0 25.685333-14.208 48.64-35.456 60.672l62.677333 13.397334 3.2 0.896c7.381333 2.389333 13.653333 7.466667 17.664 14.250666l27.306667 46.506667 1.536 2.858667a32 32 0 0 1-54.954667 32.256l-1.749333-2.730667-20.224-34.389333-18.005333-3.84 7.168 43.52 40.874666 66.773333 36.906667 34.133333 2.304 2.389334a32 32 0 0 1-43.264 46.72l-2.474667-2.133334-40.106666-37.12a32.128 32.128 0 0 1-5.546667-6.741333l-25.173333-41.130667-26.581334 27.008-14.378666 49.792a32 32 0 0 1-61.525334-17.749333l16.64-57.6 1.365334-3.712a32 32 0 0 1 6.613333-9.856l49.536-50.304-2.133333-13.013333-3.498667 4.010666a32 32 0 0 1-19.456 10.581334l-55.04 8.106666-3.242667 0.341334a32.042667 32.042667 0 0 1-6.058666-63.616l43.349333-6.4 39.893333-45.568a69.376 69.376 0 0 1-56.832-67.882667c0-37.674667 30.506667-69.546667 69.12-69.546667z m-224-170.666666a32 32 0 0 1 0 64h-213.333333a32 32 0 0 1 0-64h213.333333z m170.666667-170.666667a32 32 0 0 1 0 64h-384a32 32 0 0 1 0-64h384z" p-id="19346" fill="#0fb7ea"></path></svg>                  </div>
                </div>
                <div style="margin-left: 15px;">
                  <div class="checkin_information_single_people">访客通行记录</div>
                  <div>您可查询访客通行记录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="checkin_information_attendance">
          <div class="checkin_information_attendance_top">
            <div class="checkin_information_attendance_top_title">来访统计
              <el-radio-group v-model="visitorStatisticsSearchType" size="medium" style="margin-left: 20px;">
                <el-radio-button :label="1">今日</el-radio-button>
                <el-radio-button :label="2">本周</el-radio-button>
                <el-radio-button :label="3">本月</el-radio-button>
              </el-radio-group>
            </div>
            <div><el-button type="text" style="color:#409EFF" @click="handleToVisitor(0)">查看 <i class="el-icon-arrow-right"></i></el-button></div>
          </div>
          <div class="checkin_information_attendance_content" style="">
            <div class="checkin_information_visitor_log">
              <div style="display: flex; justify-content: center;height: 100%;">
                <div class="checkin_information_visitor_echart">
                  <VisitStats :type="visitorStatisticsSearchType"/>
                </div>
                <div class="checkin_applet_content">
                  <div class="applet">
                    <div class="title">「科密访客」</div>
                    <div class="applet_image">
                      <img :src="appletIcon"/>
                    </div>
                    <div class="description">关注「科密访客」小程序，获取更多服务</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="checkin_information_visitor_log">
              <visitor-down-log-table/>
            </div>
          </div>
        </div>
      </div>
      <company-footer-info />
    </div>
  </div>
</template>


<script>
import CommonlyMenu from "@/views/home/compnents/CommonlyMenu.vue";
import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
import InformationCard from "@/components/InformationCard.vue";
import VisitorCard from "@/views/home/compnents/VisitorCard.vue";
import EventApprovalCard from "@/views/home/compnents/EventApprovalCard.vue";
import InviteIcon from "@/assets/visitor/head.png";
import AppletIcon from '@/assets/visitor/applet.jpg';
import VisitStats from "@/views/visitor/components/VisitStats.vue";
import VisitorDownLogTable from "@/views/visitor/components/visitor-down-log-table.vue";
export default {
  components: {
    VisitorDownLogTable,
    EventApprovalCard, VisitorCard, InformationCard, CompanyFooterInfo, CommonlyMenu, VisitStats, PassageLogTable: VisitorDownLogTable},
  data() {
    return {
      inviteIcon: InviteIcon,
      appletIcon: AppletIcon,
      visitorStatisticsSearchType: 1,
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleToVisitor(params){
      this.$router.push({
        name: 'visitorApply',
        params: {
          invite: params
        }
      })
    },
    handleToVisitorLog(){
      this.$router.push({
        name: 'visitorPassageLog'
      })
    },
    handleToVisitorSetting(){
      this.$router.push({
        name: 'visitorSetting'
      })
    }
  }
};
</script>